/**
 * Device detection for PWA install flows (desktop, Android, iOS)
 */

export const isIOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

export const isAndroid = () => {
  return /android/i.test(window.navigator.userAgent.toLowerCase());
};

export const isMobileDevice = () => isIOS() || isAndroid();

export const isDesktopDevice = () => !isMobileDevice();

export const isInStandaloneMode = () => {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (('standalone' in window.navigator) && window.navigator.standalone)
  );
};

export const getInstallPlatform = () => {
  if (isInStandaloneMode()) {
    return null;
  }

  if (isIOS()) {
    return 'ios';
  }

  if (isAndroid()) {
    return 'android';
  }

  return 'desktop';
};

export const shouldShowIOSInstallPrompt = () => getInstallPlatform() === 'ios';

export const shouldShowAndroidInstallPrompt = () => getInstallPlatform() === 'android';

export const shouldShowDesktopInstallPrompt = () => getInstallPlatform() === 'desktop';

export const getBrowser = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (/safari/.test(userAgent) && !/chrome|crios|fxios/.test(userAgent)) {
    return 'safari';
  } else if (/crios/.test(userAgent)) {
    return 'chrome';
  } else if (/fxios/.test(userAgent)) {
    return 'firefox';
  }
  return 'other';
};

